import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/sunpay/step1.png'
import _imports_1 from '@/assets/images/annex/step1.png'
import _imports_2 from '@/assets/images/annex/step2.png'
import _imports_3 from '@/assets/images/icon-copy.png'
import _imports_4 from '@/assets/images/sunpay/step3.png'
import _imports_5 from '@/assets/images/annex/step3.png'
import _imports_6 from '@/assets/images/annex/status/1.png'
import _imports_7 from '@/assets/images/annex/status/2.png'
import _imports_8 from '@/assets/images/annex/status/3.png'


_pushScopeId("data-v-419f6b6b")
const _hoisted_1 = { class: "solt" }
const _hoisted_2 = {
  key: 0,
  class: "steps"
}
const _hoisted_3 = { class: "head" }
const _hoisted_4 = { class: "title" }
const _hoisted_5 = { class: "icon" }
const _hoisted_6 = {
  key: 0,
  src: _imports_0,
  alt: "step1"
}
const _hoisted_7 = {
  key: 1,
  src: _imports_1,
  alt: "step1"
}
const _hoisted_8 = { class: "time" }
const _hoisted_9 = { class: "totals font-bold" }
const _hoisted_10 = { class: "number" }
const _hoisted_11 = { class: "body" }
const _hoisted_12 = { class: "icons" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "name" }
const _hoisted_15 = { class: "icon" }
const _hoisted_16 = ["src", "alt"]
const _hoisted_17 = { class: "coin" }
const _hoisted_18 = { class: "cname font-bold" }
const _hoisted_19 = { class: "value" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "circle" }, null, -1)
const _hoisted_21 = {
  key: 0,
  class: "title"
}
const _hoisted_22 = { class: "icons" }
const _hoisted_23 = ["onClick"]
const _hoisted_24 = { class: "name" }
const _hoisted_25 = { class: "icon" }
const _hoisted_26 = ["src", "alt"]
const _hoisted_27 = { class: "value" }
const _hoisted_28 = { class: "font-bold" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", { class: "circle" }, null, -1)
const _hoisted_30 = { class: "footer" }
const _hoisted_31 = { class: "desc" }
const _hoisted_32 = { class: "action" }
const _hoisted_33 = ["href"]
const _hoisted_34 = {
  key: 1,
  class: "steps loader result"
}
const _hoisted_35 = { class: "head" }
const _hoisted_36 = { class: "title" }
const _hoisted_37 = { class: "icon" }
const _hoisted_38 = {
  key: 0,
  src: _imports_0,
  alt: "step1"
}
const _hoisted_39 = {
  key: 1,
  src: _imports_2,
  alt: "step2"
}
const _hoisted_40 = { class: "time" }
const _hoisted_41 = { class: "block" }
const _hoisted_42 = { class: "block" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("span", { class: "colon" }, [
  /*#__PURE__*/_createElementVNode("i")
], -1)
const _hoisted_44 = { class: "block" }
const _hoisted_45 = { class: "block" }
const _hoisted_46 = { class: "body" }
const _hoisted_47 = { class: "qrcode" }
const _hoisted_48 = { class: "icon" }
const _hoisted_49 = ["src", "alt"]
const _hoisted_50 = { class: "value" }
const _hoisted_51 = {
  key: 0,
  class: "fiat"
}
const _hoisted_52 = { class: "info" }
const _hoisted_53 = { class: "address" }
const _hoisted_54 = { class: "value" }
const _hoisted_55 = { class: "icon" }
const _hoisted_56 = ["src", "alt"]
const _hoisted_57 = { class: "name" }
const _hoisted_58 = { class: "font-bold" }
const _hoisted_59 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: "copy"
}, null, -1)
const _hoisted_60 = [
  _hoisted_59
]
const _hoisted_61 = { class: "footer" }
const _hoisted_62 = { class: "tips" }
const _hoisted_63 = { class: "action" }
const _hoisted_64 = {
  key: 2,
  class: "steps loader results"
}
const _hoisted_65 = { class: "head" }
const _hoisted_66 = { class: "title" }
const _hoisted_67 = { class: "icon" }
const _hoisted_68 = {
  key: 0,
  src: _imports_4,
  alt: "step3"
}
const _hoisted_69 = {
  key: 1,
  src: _imports_5,
  alt: "step3"
}
const _hoisted_70 = /*#__PURE__*/_createElementVNode("div", { class: "time" }, null, -1)
const _hoisted_71 = { class: "body" }
const _hoisted_72 = /*#__PURE__*/_createElementVNode("div", { class: "icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/images/status/payment.png",
    alt: "icon"
  })
], -1)
const _hoisted_73 = { class: "remark" }
const _hoisted_74 = {
  key: 3,
  class: "steps status"
}
const _hoisted_75 = { class: "head" }
const _hoisted_76 = { class: "title" }
const _hoisted_77 = { class: "icon" }
const _hoisted_78 = {
  key: 0,
  src: _imports_4,
  alt: "step3"
}
const _hoisted_79 = {
  key: 1,
  src: _imports_5,
  alt: "step3"
}
const _hoisted_80 = /*#__PURE__*/_createElementVNode("div", { class: "time" }, null, -1)
const _hoisted_81 = { class: "body" }
const _hoisted_82 = {
  key: 0,
  class: "icon"
}
const _hoisted_83 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_6,
  alt: "icon"
}, null, -1)
const _hoisted_84 = { class: "success" }
const _hoisted_85 = {
  key: 1,
  class: "icon"
}
const _hoisted_86 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_7,
  alt: "icon"
}, null, -1)
const _hoisted_87 = { class: "fail" }
const _hoisted_88 = {
  key: 2,
  class: "icon"
}
const _hoisted_89 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_8,
  alt: "icon"
}, null, -1)
const _hoisted_90 = { class: "cancel" }
const _hoisted_91 = { class: "label" }
const _hoisted_92 = { class: "label" }
const _hoisted_93 = { class: "value" }
const _hoisted_94 = { class: "label" }
const _hoisted_95 = { class: "value" }
const _hoisted_96 = { class: "label" }
const _hoisted_97 = { class: "value" }
const _hoisted_98 = { key: 0 }
const _hoisted_99 = { key: 0 }
const _hoisted_100 = { class: "label" }
const _hoisted_101 = { class: "value" }
const _hoisted_102 = { class: "footer" }
const _hoisted_103 = { class: "action" }
_popScopeId()

export function render(_ctx: any,_cache: any) {
  const _component_Types = _resolveComponent("Types")!
  const _component_van_count_down = _resolveComponent("van-count-down")!
  const _component_VueQrcode = _resolveComponent("VueQrcode")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.steps == 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                (['sunpaysandbox', 'sunpayprod'].includes(_ctx.dev))
                  ? (_openBlock(), _createElementBlock("img", _hoisted_6))
                  : (_openBlock(), _createElementBlock("img", _hoisted_7))
              ]),
              _createTextVNode(" " + _toDisplayString(_ctx.$t("defray.choose")), 1)
            ]),
            _createElementVNode("div", _hoisted_8, [
              _renderSlot(_ctx.$slots, "times", {}, undefined, true)
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("span", null, _toDisplayString(_ctx.$t("defray.total")), 1),
            _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.result?.amount) + " " + _toDisplayString(_ctx.result?.currency), 1)
          ]),
          _createVNode(_component_Types, {
            modelValue: _ctx.type,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.type = $event)),
            showCrypto: _ctx.showCrypto,
            "onUpdate:showCrypto": _cache[1] || (_cache[1] = ($event: any) => (_ctx.showCrypto = $event)),
            showFiat: _ctx.showFiat,
            "onUpdate:showFiat": _cache[2] || (_cache[2] = ($event: any) => (_ctx.showFiat = $event))
          }, null, 8, ["modelValue", "showCrypto", "showFiat"]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", {
              class: _normalizeClass(["project", { f2: _ctx.result?.crypto_currency_config_list?.length > 2 }])
            }, [
              _createElementVNode("div", _hoisted_12, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.result?.crypto_currency_config_list, (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: _normalizeClass(["item", { active: item.currency == _ctx.checkCurrency.currency }]),
                    key: item.currency,
                    onClick: ($event: any) => (_ctx.setCheckCurrency(item))
                  }, [
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("img", {
                          src: item.web_icon,
                          alt: item.currency
                        }, null, 8, _hoisted_16)
                      ]),
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("div", _hoisted_18, _toDisplayString(item.currency), 1),
                        _createElementVNode("span", null, _toDisplayString(item.currency), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_19, [
                      _createTextVNode(" ≈ " + _toDisplayString(item.amount) + " ", 1),
                      _hoisted_20
                    ])
                  ], 10, _hoisted_13))
                }), 128))
              ])
            ], 2),
            (_ctx.checkCurrency?.payment_type_list?.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString(_ctx.$t("defray.blockchain")), 1))
              : _createCommentVNode("", true),
            (_ctx.checkCurrency?.payment_type_list?.length)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: _normalizeClass(["project", { f2: _ctx.checkCurrency?.payment_type_list?.length > 2 }])
                }, [
                  _createElementVNode("div", _hoisted_22, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.checkCurrency?.payment_type_list, (item, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: _normalizeClass(["item", { active: item == _ctx.checkChain }]),
                        key: index,
                        onClick: ($event: any) => (_ctx.setCheckChain(item))
                      }, [
                        _createElementVNode("div", _hoisted_24, [
                          _createElementVNode("div", _hoisted_25, [
                            _createElementVNode("img", {
                              src: _ctx.checkCurrency?.web_icon,
                              alt: _ctx.checkCurrency?.currency
                            }, null, 8, _hoisted_26)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_27, [
                          _createElementVNode("div", _hoisted_28, _toDisplayString(item), 1),
                          _hoisted_29
                        ])
                      ], 10, _hoisted_23))
                    }), 128))
                  ])
                ], 2))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_30, [
            _createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.$t("defray.remark", {
              brand: ["sunpaysandbox", "sunpayprod"].includes(_ctx.dev) ? "Sun Pay" : "Klickl Pay"
            })), 1),
            _createElementVNode("div", _hoisted_32, [
              (_ctx.result?.cancel_url)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    class: "button gery",
                    href: _ctx.result?.cancel_url
                  }, _toDisplayString(_ctx.$t("defray.cancel")), 9, _hoisted_33))
                : _createCommentVNode("", true),
              _createElementVNode("div", {
                class: "button dark",
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.next && _ctx.next(...args)))
              }, _toDisplayString(_ctx.$t("create")), 1)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.steps == 2)
      ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
          _createElementVNode("div", _hoisted_35, [
            _createElementVNode("div", _hoisted_36, [
              _createElementVNode("div", _hoisted_37, [
                (['sunpaysandbox', 'sunpayprod'].includes(_ctx.dev))
                  ? (_openBlock(), _createElementBlock("img", _hoisted_38))
                  : (_openBlock(), _createElementBlock("img", _hoisted_39))
              ]),
              _createTextVNode(" " + _toDisplayString(_ctx.$t("defray.scan")), 1)
            ]),
            _createElementVNode("div", _hoisted_40, [
              _createVNode(_component_van_count_down, {
                time: Number(_ctx.result?.extend?.expires_in) * 1000,
                format: "mm:ss",
                onFinish: _ctx.finish
              }, {
                default: _withCtx((timeData) => [
                  _createElementVNode("span", _hoisted_41, _toDisplayString(_ctx.SplitNumber(timeData.minutes)[0]), 1),
                  _createElementVNode("span", _hoisted_42, _toDisplayString(_ctx.SplitNumber(timeData.minutes)[1]), 1),
                  _hoisted_43,
                  _createElementVNode("span", _hoisted_44, _toDisplayString(_ctx.SplitNumber(timeData.seconds)[0]), 1),
                  _createElementVNode("span", _hoisted_45, _toDisplayString(_ctx.SplitNumber(timeData.seconds)[1]), 1)
                ]),
                _: 1
              }, 8, ["time", "onFinish"])
            ])
          ]),
          _createElementVNode("div", _hoisted_46, [
            _createElementVNode("div", _hoisted_47, [
              _createVNode(_component_VueQrcode, {
                value: _ctx.result?.extend?.address,
                tag: "img",
                options: {
              width: 160,
              margin: 0
            }
              }, null, 8, ["value"]),
              _createElementVNode("div", _hoisted_48, [
                _createElementVNode("img", {
                  src: _ctx.result?.extend?.web_icon,
                  alt: _ctx.result?.extend?.currency
                }, null, 8, _hoisted_49)
              ]),
              _createElementVNode("p", null, _toDisplayString(_ctx.$t("defray.open")), 1),
              _createElementVNode("div", _hoisted_50, [
                _createElementVNode("span", null, _toDisplayString(_ctx.$t("defray.pay")), 1),
                _createElementVNode("span", {
                  class: "number",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.copy(_ctx.result?.extend.amount?.toString())))
                }, _toDisplayString(_ctx.result?.extend.amount) + " " + _toDisplayString(_ctx.result?.extend.currency), 1),
                (_ctx.result?.currency !== _ctx.result?.extend.currency)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_51, " ≈ " + _toDisplayString(_ctx.result?.amount) + " " + _toDisplayString(_ctx.result?.currency), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_52, [
              _createElementVNode("ul", null, [
                _createElementVNode("li", _hoisted_53, [
                  _createElementVNode("div", _hoisted_54, [
                    _createElementVNode("div", _hoisted_55, [
                      _createElementVNode("img", {
                        src: _ctx.result?.extend?.web_icon,
                        alt: _ctx.result?.extend?.currency
                      }, null, 8, _hoisted_56)
                    ]),
                    _createElementVNode("div", _hoisted_57, [
                      _createElementVNode("div", _hoisted_58, _toDisplayString(_ctx.result?.extend.currency) + " - " + _toDisplayString(_ctx.result?.extend.chain_type), 1),
                      _createElementVNode("p", null, _toDisplayString(_ctx.result?.extend?.address), 1)
                    ])
                  ]),
                  _createElementVNode("div", {
                    class: "extend",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.copy(_ctx.result?.extend?.address)))
                  }, _hoisted_60)
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_61, [
            _createElementVNode("div", _hoisted_62, [
              _createElementVNode("ul", null, [
                _createElementVNode("li", null, _toDisplayString(_ctx.$t("defray.tip1", {
                  coin: _ctx.result?.extend?.currency,
                  blockchain: _ctx.result?.extend?.chain_type
                })), 1),
                _createElementVNode("li", null, _toDisplayString(_ctx.$t("defray.tip2")), 1),
                _createElementVNode("li", null, _toDisplayString(_ctx.$t("defray.tip3")), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_63, [
              _createElementVNode("div", {
                class: "button full",
                onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.cancelOrder && _ctx.cancelOrder(...args)))
              }, _toDisplayString(_ctx.$t("defray.cancel")), 1),
              _createElementVNode("div", {
                class: "button full dark",
                onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.next && _ctx.next(...args)))
              }, _toDisplayString(_ctx.$t("paid")), 1)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.steps == 3)
      ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
          _createElementVNode("div", _hoisted_65, [
            _createElementVNode("div", _hoisted_66, [
              _createElementVNode("div", _hoisted_67, [
                (['sunpaysandbox', 'sunpayprod'].includes(_ctx.dev))
                  ? (_openBlock(), _createElementBlock("img", _hoisted_68))
                  : (_openBlock(), _createElementBlock("img", _hoisted_69))
              ]),
              _createTextVNode(" " + _toDisplayString(_ctx.$t("defray.status.title")), 1)
            ]),
            _hoisted_70
          ]),
          _createElementVNode("div", _hoisted_71, [
            _hoisted_72,
            _createElementVNode("h3", null, _toDisplayString(_ctx.$t("defray.processing")), 1),
            _createElementVNode("div", _hoisted_73, [
              _createElementVNode("ul", null, [
                _createElementVNode("li", null, _toDisplayString(_ctx.$t("defray.details[0]")), 1),
                _createElementVNode("li", null, _toDisplayString(_ctx.$t("defray.details[1]")), 1),
                _createElementVNode("li", null, _toDisplayString(_ctx.$t("defray.details[2]")), 1)
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.steps == 4)
      ? (_openBlock(), _createElementBlock("div", _hoisted_74, [
          _createElementVNode("div", _hoisted_75, [
            _createElementVNode("div", _hoisted_76, [
              _createElementVNode("div", _hoisted_77, [
                (['sunpaysandbox', 'sunpayprod'].includes(_ctx.dev))
                  ? (_openBlock(), _createElementBlock("img", _hoisted_78))
                  : (_openBlock(), _createElementBlock("img", _hoisted_79))
              ]),
              _createTextVNode(" " + _toDisplayString(_ctx.$t("defray.status.title")), 1)
            ]),
            _hoisted_80
          ]),
          _createElementVNode("div", _hoisted_81, [
            (_ctx.result?.extend?.order_status == 'SUCCESS')
              ? (_openBlock(), _createElementBlock("div", _hoisted_82, [
                  _hoisted_83,
                  _createElementVNode("h3", _hoisted_84, _toDisplayString(_ctx.$t("defray.status.success.title")), 1),
                  _createElementVNode("p", null, _toDisplayString(_ctx.$t("defray.status.success.desc")), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.result?.extend?.order_status == 'FAIL')
              ? (_openBlock(), _createElementBlock("div", _hoisted_85, [
                  _hoisted_86,
                  _createElementVNode("h3", _hoisted_87, _toDisplayString(_ctx.$t("defray.status.fail.title")), 1),
                  _createElementVNode("p", null, _toDisplayString(_ctx.$t("defray.status.fail.desc")), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.result?.extend?.order_status == 'CANCEL')
              ? (_openBlock(), _createElementBlock("div", _hoisted_88, [
                  _hoisted_89,
                  _createElementVNode("h3", _hoisted_90, _toDisplayString(_ctx.$t("defray.status.cancel.title")), 1),
                  _createElementVNode("p", null, _toDisplayString(_ctx.$t("defray.status.cancel.desc")), 1)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("ul", null, [
              _createElementVNode("li", null, [
                _createElementVNode("div", _hoisted_91, _toDisplayString(_ctx.$t("defray.orderNo")), 1),
                _createElementVNode("div", {
                  class: "value link",
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.copy(_ctx.result?.extend?.out_order_no)))
                }, _toDisplayString(_ctx.result?.extend?.out_order_no), 1)
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("div", _hoisted_92, _toDisplayString(_ctx.$t("defray.businessName")), 1),
                _createElementVNode("div", _hoisted_93, _toDisplayString(_ctx.result?.extend?.business_name || "--"), 1)
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("div", _hoisted_94, _toDisplayString(_ctx.$t("defray.productName")), 1),
                _createElementVNode("div", _hoisted_95, _toDisplayString(_ctx.result?.extend?.product_name || "--"), 1)
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("div", _hoisted_96, _toDisplayString(_ctx.$t("defray.amount")), 1),
                _createElementVNode("div", _hoisted_97, [
                  _createTextVNode(_toDisplayString(_ctx.result?.amount) + " " + _toDisplayString(_ctx.result?.currency) + " ", 1),
                  (_ctx.result?.currency !== _ctx.result?.extend.currency)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_98, " ≈ " + _toDisplayString(_ctx.result?.extend?.amount) + " " + _toDisplayString(_ctx.result?.extend?.currency), 1))
                    : _createCommentVNode("", true)
                ])
              ]),
              (_ctx.result?.extend?.payment_time)
                ? (_openBlock(), _createElementBlock("li", _hoisted_99, [
                    _createElementVNode("div", _hoisted_100, _toDisplayString(_ctx.$t("defray.time")), 1),
                    _createElementVNode("div", _hoisted_101, _toDisplayString(_ctx.FormatDateZone(_ctx.result?.extend?.payment_time, 0)), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_102, [
            _createElementVNode("div", _hoisted_103, [
              (_ctx.result?.redirect_url)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "button full dark",
                    onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.redirect && _ctx.redirect(...args)))
                  }, _toDisplayString(_ctx.$t("complete")), 1))
                : _createCommentVNode("", true)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}